// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__MSnXB","row":"ProcedureTreatmentSummary_row__1P5pe"};